module.exports = __webpack_public_path__ + "static/media/es-ES.2a34a03a.md";